var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.666,
    height: 20.666,
    viewBox: "0 0 20.666 20.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_5279123_tweet_twitter_twitter_logo_icon",
    "data-name": "5279123_tweet_twitter_twitter logo_icon",
    d: "M10.333,0A10.333,10.333,0,1,1,0,10.333,10.338,10.338,0,0,1,10.333,0ZM8.513,15.829a7.025,7.025,0,0,0,7.073-7.073c0-.108,0-.217-.005-.32a5.092,5.092,0,0,0,1.242-1.289,5.044,5.044,0,0,1-1.428.392,2.484,2.484,0,0,0,1.093-1.376,5.034,5.034,0,0,1-1.577.6,2.487,2.487,0,0,0-4.3,1.7,2.279,2.279,0,0,0,.067.567,7.051,7.051,0,0,1-5.124-2.6,2.484,2.484,0,0,0,.773,3.315A2.442,2.442,0,0,1,5.2,9.442v.031A2.488,2.488,0,0,0,7.2,11.911,2.479,2.479,0,0,1,6.544,12a2.371,2.371,0,0,1-.469-.046,2.482,2.482,0,0,0,2.32,1.727,5,5,0,0,1-3.088,1.062,4.524,4.524,0,0,1-.593-.036,6.926,6.926,0,0,0,3.8,1.124Z",
    fill: "#e4c7ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.57727ecb7a1ad8c31da723e7443a695b.svg";
export { ForwardRef as ReactComponent };